// Frontend mirror of the backend live-price window
// (pythonbackend/services/cronjob_update_live_prices.is_market_hours): weekdays only, a
// broad UTC window covering EU + US regular sessions. Used to poll the holdings/portfolio/
// watchlist queries for fresh `live_prices` only while it's worth it.

export const LIVE_PRICE_REFETCH_MS = 60 * 60 * 1000; // 1h — matches the backend cadence

const MARKET_OPEN_UTC_HOUR = 7;
const MARKET_CLOSE_UTC_HOUR = 22;

export function isMarketHoursUTC(now: Date = new Date()): boolean {
  const day = now.getUTCDay(); // 0=Sun … 6=Sat
  if (day === 0 || day === 6) return false;
  const hour = now.getUTCHours();
  return hour >= MARKET_OPEN_UTC_HOUR && hour < MARKET_CLOSE_UTC_HOUR;
}

// Value for TanStack Query's `refetchInterval`: poll during market hours, otherwise stop.
export function liveRefetchInterval(): number | false {
  return isMarketHoursUTC() ? LIVE_PRICE_REFETCH_MS : false;
}
